<template>
  <div class="cmp-back-top">
    <a @click="goTop" v-show="showGoTop"></a>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    // 文字是否为白色
    isWhite: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showGoTop: false
    }
  },
  methods: {
    handleScroll() {
      let scrolltop = document.documentElement.scrollTop 
      if(scrolltop > window.innerHeight){
        this.showGoTop = true
      }else{
        this.showGoTop = false
      }
    },
    goTop() {
      window.scrollTo({
        top: 0
      })
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="scss" scoped>
.cmp-back-top {
  position: fixed;
  right: 50px;
  bottom: 50px;
  z-index: 9;
  a {
    display: inline-block;
    width: 56px;
    height: 56px;
    background: url(~@images/btn-next.png) no-repeat center center;
    background-size: 100% 100%;
    transform: rotate(-90deg);
    // opacity: 0.5;
  }
}
</style>


